// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_pdf-lib_es_index_js":"5ce62a3771d606d1","src_app_home_home_component_ts":"78d0c02601d4dc48"}[chunkId] + ".js";
};